import DOMPurify from "dompurify";

const cmsParser = (key, cmslabels) => {
  if (cmslabels && cmslabels.length > 0) {
    let obj = cmslabels.find((o) => o.key === key);
    if (obj) {
      return DOMPurify.sanitize(obj.value.microContentValue);
    }
  }
  return "";
};

export default cmsParser;
